import { render } from "./FollowUpNotesReadOverlay.vue?vue&type=template&id=659a1d2a&lang=pug"
import script from "./FollowUpNotesReadOverlay.vue?vue&type=script&lang=js"
export * from "./FollowUpNotesReadOverlay.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__